
import { useState, useEffect, useRef } from 'react';

const contactOptions = [
  {
    name: 'WhatsApp',
    icon: 'ri-whatsapp-line',
    color: 'bg-green-500 hover:bg-green-600',
    url: 'https://wa.me/79534940353?text=Hola%20Digital%20Licence%20Store%2C%20estoy%20interesado%20en%20adquirir%20licencias%20digitales.%20%C2%BFPodr%C3%ADan%20brindarme%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20productos%20y%20precios%3F',
  },
  {
    name: 'Telegram',
    icon: 'ri-telegram-line',
    color: 'bg-sky-500 hover:bg-sky-600',
    url: 'https://t.me/Sup0rteWin',
  },
  {
    name: 'Email',
    icon: 'ri-mail-line',
    color: 'bg-amber-500 hover:bg-amber-600',
    url: 'mailto:DigitalLicenceStore@offersshopping.com?subject=Consulta%20sobre%20Licencias%20Digitales&body=Hola%20equipo%20de%20Digital%20Licence%20Store%2C%0A%0AEstoy%20interesado%20en%20adquirir%20licencias%20digitales%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%3A%0A%0A-%20Productos%20disponibles%0A-%20Precios%20y%20promociones%0A-%20M%C3%A9todos%20de%20pago%0A-%20Tiempo%20de%20entrega%0A%0ASaludos%20cordiales.',
  },
];

const ContactCloud = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [pulse, setPulse] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => setPulse(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      {/* Floating WhatsApp button - visible on all screens */}
      <a
        href="https://wa.me/79534940353?text=Hola%20Digital%20Licence%20Store%2C%20estoy%20interesado%20en%20adquirir%20licencias%20digitales.%20%C2%BFPodr%C3%ADan%20brindarme%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20productos%20y%20precios%3F"
        target="_blank"
        rel="nofollow noopener noreferrer"
        className="fixed bottom-6 left-4 z-50 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-3 rounded-full shadow-xl cursor-pointer transition-all active:scale-95"
        aria-label="Contactar por WhatsApp"
      >
        <span className="w-6 h-6 flex items-center justify-center">
          <i className="ri-whatsapp-line text-2xl"></i>
        </span>
        <span className="text-sm font-semibold whitespace-nowrap">WhatsApp</span>
      </a>

      {/* Contact cloud - main button */}
      <div ref={containerRef} className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
        {/* Options */}
        {isOpen && (
          <div className="flex flex-col gap-2">
            {contactOptions.map((option, index) => (
              <a
                key={option.name}
                href={option.url}
                target={option.url.startsWith('mailto:') ? '_self' : '_blank'}
                rel="nofollow noopener noreferrer"
                className={`flex items-center gap-3 px-4 py-2.5 rounded-full text-white shadow-lg cursor-pointer transition-all duration-300 whitespace-nowrap ${option.color}`}
                style={{
                  animation: `slideIn 0.3s ease-out ${index * 60}ms both`,
                }}
              >
                <span className="text-sm font-medium">{option.name}</span>
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${option.icon} text-lg`}></i>
                </span>
              </a>
            ))}
          </div>
        )}

        {/* Tooltip */}
        {!isOpen && (
          <div className="absolute bottom-full right-0 mb-2 pointer-events-none hidden sm:block">
            <div className="bg-gray-900 text-white text-xs px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap animate-bounce">
              ¿Necesitas ayuda? 💬
            </div>
          </div>
        )}

        {/* Main Button */}
        <button
          onClick={() => {
            setIsOpen(!isOpen);
            setPulse(false);
          }}
          className={`relative w-12 h-12 sm:w-14 sm:h-14 rounded-full shadow-xl cursor-pointer flex items-center justify-center transition-all duration-300 ${
            isOpen
              ? 'bg-gray-700 hover:bg-gray-800 rotate-45'
              : 'bg-gradient-to-br from-teal-500 to-emerald-600 hover:from-teal-600 hover:to-emerald-700'
          }`}
          aria-label="Abrir opciones de contacto"
        >
          {pulse && !isOpen && (
            <>
              <span className="absolute inset-0 rounded-full bg-teal-400/40 animate-ping"></span>
              <span className="absolute inset-0 rounded-full bg-teal-400/20 animate-pulse"></span>
            </>
          )}
          <span className="w-6 h-6 flex items-center justify-center text-white">
            <i className={`${isOpen ? 'ri-close-line' : 'ri-chat-smile-3-line'} text-xl sm:text-2xl`}></i>
          </span>
        </button>

        <style>{`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateX(20px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
        `}</style>
      </div>
    </>
  );
};

export default ContactCloud;
